export const brands = [
  { value: 'Anita' },
  { value: 'Bluebella' },
  { value: 'Bravissimo' },
  { value: 'Calvin Klein' },
  { value: 'Chantelle' },
  { value: 'Cleo' },
  { value: 'Curvy Kate' },
  { value: 'Elomi' },
  { value: 'Fantasie' },
  { value: 'Freya' },
  { value: 'Glamorise' },
  { value: 'Goddess' },
  { value: 'Gossard' },
  { value: 'M&S', dataCup: '1' },
  { value: 'Marie Jo' },
  { value: 'Mimi Holiday' },
  { value: 'Nubian Skin' },
  { value: 'Panache' },
  { value: 'Prima Donna', dataCup: '1' },
  { value: 'Rougette' },
  { value: 'Royce', dataCup: '1', dataBack: '1' },
  { value: 'Rosa Faia' },
  { value: 'Shock Absorber', dataBack: '1' },
  { value: 'Sugar Candy' },
  { value: 'Simone Perele' },
  { value: 'Third Love' },
  { value: 'Triumph', dataCup: '-1' },
  { value: 'Ultimo' },
  { value: "Victoria's Secret" },
  { value: 'Wacoal', dataCup: '-1', dataBack: '-1' },
  { value: 'Wonderbra', dataBack: '1' },
  { value: 'Other', dataCup: '0', dataBack: '0' },
];
